import { CountryType, EnumTiposDocumento } from "@/redux/models";

export const countries: readonly CountryType[] = [
  { code: 'AD', label: 'Andorra', phone: '376', suggested: false, demonym: 'Andorrana' },
  { code: 'AE', label: 'Emiratos Árabes Unidos', phone: '971', suggested: false, demonym: 'Emiratí' },
  { code: 'AF', label: 'Afganistán', phone: '93', suggested: false, demonym: 'Afgana' },
  { code: 'AG', label: 'Antigua y Barbuda', phone: '1-268', suggested: false, demonym: 'Antiguanesa' },
  { code: 'AI', label: 'Anguila', phone: '1-264', suggested: false, demonym: 'Anguilense' },
  { code: 'AL', label: 'Albania', phone: '355', suggested: false, demonym: 'Albanesa' },
  { code: 'AM', label: 'Armenia', phone: '374', suggested: false, demonym: 'Armenia' },
  { code: 'AO', label: 'Angola', phone: '244', suggested: false, demonym: 'Angolana' },
  { code: 'AQ', label: 'Antártida', phone: '672', suggested: false, demonym: 'Antártica' },
  { code: 'AR', label: 'Argentina', phone: '54', suggested: false, demonym: 'Argentina' },
  { code: 'AS', label: 'Samoa Americana', phone: '1-684', suggested: false, demonym: 'Samoana Americana' },
  { code: 'AT', label: 'Austria', phone: '43', suggested: false, demonym: 'Austriaca' },
  { code: 'AU', label: 'Australia', phone: '61', suggested: true, demonym: 'Australiana' },
  { code: 'AW', label: 'Aruba', phone: '297', suggested: false, demonym: 'Arubeña' },
  { code: 'AX', label: 'Islas Åland', phone: '358', suggested: false, demonym: 'Ålandesa' },
  { code: 'AZ', label: 'Azerbaiyán', phone: '994', suggested: false, demonym: 'Azerbaiyana' },
  { code: 'BA', label: 'Bosnia y Herzegovina', phone: '387', suggested: false, demonym: 'Bosnia y Herzegovina' },
  { code: 'BB', label: 'Barbados', phone: '1-246', suggested: false, demonym: 'Barbadense' },
  { code: 'BD', label: 'Bangladés', phone: '880', suggested: false, demonym: 'Bangladesí' },
  { code: 'BE', label: 'Bélgica', phone: '32', suggested: false, demonym: 'Belga' },
  { code: 'BF', label: 'Burkina Faso', phone: '226', suggested: false, demonym: 'Burkinesa' },
  { code: 'BG', label: 'Bulgaria', phone: '359', suggested: false, demonym: 'Búlgara' },
  { code: 'BH', label: 'Baréin', phone: '973', suggested: false, demonym: 'Bahreiní' },
  { code: 'BI', label: 'Burundi', phone: '257', suggested: false, demonym: 'Burundesa' },
  { code: 'BJ', label: 'Benín', phone: '229', suggested: false, demonym: 'Beninesa' },
  { code: 'BL', label: 'San Bartolomé', phone: '590', suggested: false, demonym: 'Barthelense' },
  { code: 'BM', label: 'Bermudas', phone: '1-441', suggested: false, demonym: 'Bermudeña' },
  { code: 'BN', label: 'Brunéi', phone: '673', suggested: false, demonym: 'Bruneana' },
  { code: 'BO', label: 'Bolivia', phone: '591', suggested: false, demonym: 'Boliviana' },
  { code: 'BR', label: 'Brasil', phone: '55', suggested: false, demonym: 'Brasileña' },
  { code: 'BS', label: 'Bahamas', phone: '1-242', suggested: false, demonym: 'Bahameña' },
  { code: 'BT', label: 'Bután', phone: '975', suggested: false, demonym: 'Butanesa' },
  { code: 'BV', label: 'Isla Bouvet', phone: '47', suggested: false, demonym: 'Bouvetense' },
  { code: 'BW', label: 'Botsuana', phone: '267', suggested: false, demonym: 'Botsuanesa' },
  { code: 'BY', label: 'Bielorrusia', phone: '375', suggested: false, demonym: 'Bielorrusa' },
  { code: 'BZ', label: 'Belice', phone: '501', suggested: false, demonym: 'Beliceña' },
  { code: 'CA', label: 'Canadá', phone: '1', suggested: false, demonym: 'Canadiense' },
  { code: 'CC', label: 'Islas Cocos', phone: '61', suggested: false, demonym: 'Cocolense' },
  { code: 'CD', label: 'Congo', phone: '243', suggested: false, demonym: 'Congoleña' },
  { code: 'CF', label: 'República Centroafricana', phone: '236', suggested: false, demonym: 'Centroafricana' },
  { code: 'CH', label: 'Suiza', phone: '41', suggested: false, demonym: 'Suiza' },
  { code: 'CI', label: 'Costa de Marfil', phone: '225', suggested: false, demonym: 'Marfileña' },
  { code: 'CK', label: 'Islas Cook', phone: '682', suggested: false, demonym: 'Cookense' },
  { code: 'CL', label: 'Chile', phone: '56', suggested: false, demonym: 'Chilena' },
  { code: 'CM', label: 'Camerún', phone: '237', suggested: false, demonym: 'Camerunesa' },
  { code: 'CN', label: 'China', phone: '86', suggested: false, demonym: 'China' },
  { code: 'CO', label: 'Colombia', phone: '57', suggested: false, demonym: 'Colombiana' },
  { code: 'CR', label: 'Costa Rica', phone: '506', suggested: false, demonym: 'Costarricense' },
  { code: 'CU', label: 'Cuba', phone: '53', suggested: false, demonym: 'Cubana' },
  { code: 'CV', label: 'Cabo Verde', phone: '238', suggested: false, demonym: 'Caboverdiana' },
  { code: 'CW', label: 'Curazao', phone: '599', suggested: false, demonym: 'Curazaleña' },
  { code: 'CX', label: 'Isla de Navidad', phone: '61', suggested: false, demonym: 'Navideña' },
  { code: 'CY', label: 'Chipre', phone: '357', suggested: false, demonym: 'Chipriota' },
  { code: 'CZ', label: 'República Checa', phone: '420', suggested: false, demonym: 'Checa' },
  { code: 'DE', label: 'Alemania', phone: '49', suggested: false, demonym: 'Alemana' },
  { code: 'DJ', label: 'Yibuti', phone: '253', suggested: false, demonym: 'Yibutiana' },
  { code: 'DK', label: 'Dinamarca', phone: '45', suggested: false, demonym: 'Danesa' },
  { code: 'DM', label: 'Dominica', phone: '1-767', suggested: false, demonym: 'Domínica' }, // No cambia en género.
  { code: 'DO', label: 'República Dominicana', phone: '1-809, 1-829, 1-849', suggested: false, demonym: 'Dominicana' },
  { code: 'DZ', label: 'Argelia', phone: '213', suggested: false, demonym: 'Argelina' },
  { code: 'EC', label: 'Ecuador', phone: '593', suggested: false, demonym: 'Ecuatoriana' },
  { code: 'EE', label: 'Estonia', phone: '372', suggested: false, demonym: 'Estonia' }, // No cambia en género.
  { code: 'EG', label: 'Egipto', phone: '20', suggested: false, demonym: 'Egipcia' },
  { code: 'EH', label: 'Sahara Occidental', phone: '212', suggested: false, demonym: 'Saharaui' }, // No cambia en género.
  { code: 'ER', label: 'Eritrea', phone: '291', suggested: false, demonym: 'Eritrea' }, // No cambia en género.
  { code: 'ES', label: 'España', phone: '34', suggested: false, demonym: 'Española' },
  { code: 'ET', label: 'Etiopía', phone: '251', suggested: false, demonym: 'Etíope' },
  { code: 'FI', label: 'Finlandia', phone: '358', suggested: false, demonym: 'Finlandesa' },
  { code: 'FJ', label: 'Fiyi', phone: '679', suggested: false, demonym: 'Fiyiana' },
  { code: 'FK', label: 'Islas Malvinas', phone: '500', suggested: false, demonym: 'Malvinense' },
  { code: 'FM', label: 'Micronesia', phone: '691', suggested: false, demonym: 'Micronesa' }, // No cambia en género.
  { code: 'FO', label: 'Islas Feroe', phone: '298', suggested: false, demonym: 'Feroesa' },
  { code: 'FR', label: 'Francia', phone: '33', suggested: false, demonym: 'Francesa' },
  { code: 'GA', label: 'Gabón', phone: '241', suggested: false, demonym: 'Gabonesa' },
  { code: 'GB', label: 'Reino Unido', phone: '44', suggested: false, demonym: 'Británica' },
  { code: 'GD', label: 'Granada', phone: '1-473', suggested: false, demonym: 'Granadina' },
  { code: 'GE', label: 'Georgia', phone: '995', suggested: false, demonym: 'Georgiana' },
  { code: 'GF', label: 'Guayana Francesa', phone: '594', suggested: false, demonym: 'Guayanesa' },
  { code: 'GG', label: 'Guernsey', phone: '44', suggested: false, demonym: 'Guerneseyana' },
  { code: 'GH', label: 'Ghana', phone: '233', suggested: false, demonym: 'Ghanesa' },
  { code: 'GI', label: 'Gibraltar', phone: '350', suggested: false, demonym: 'Gibraltareña' },
  { code: 'GL', label: 'Groenlandia', phone: '299', suggested: false, demonym: 'Groenlandesa' },
  { code: 'GM', label: 'Gambia', phone: '220', suggested: false, demonym: 'Gambiana' },
  { code: 'GN', label: 'Guinea', phone: '224', suggested: false, demonym: 'Guineana' },
  { code: 'GP', label: 'Guadalupe', phone: '590', suggested: false, demonym: 'Guadalupeña' },
  { code: 'GQ', label: 'Guinea Ecuatorial', phone: '240', suggested: false, demonym: 'Ecuatoguineana' },
  { code: 'GR', label: 'Grecia', phone: '30', suggested: false, demonym: 'Helena' }, // No cambia en género.
  { code: 'GS', label: 'Islas Georgias del Sur y Sandwich del Sur', phone: '500', suggested: false, demonym: 'De Georgia del Sur y las Islas Sandwich del Sur' },
  { code: 'GT', label: 'Guatemala', phone: '502', suggested: false, demonym: 'Guatemalteca' },
  { code: 'GU', label: 'Guam', phone: '1-671', suggested: false, demonym: 'Guameña' },
  { code: 'GW', label: 'Guinea-Bisáu', phone: '245', suggested: false, demonym: 'Bisauense' },
  { code: 'GY', label: 'Guyana', phone: '592', suggested: false, demonym: 'Guyanesa' },
  { code: 'HK', label: 'Hong Kong', phone: '852', suggested: false, demonym: 'Hongkonesa' },
  { code: 'HM', label: 'Islas Heard y McDonald', phone: '672', suggested: false, demonym: 'De la Isla Heard y las Islas McDonald' },
  { code: 'HN', label: 'Honduras', phone: '504', suggested: false, demonym: 'Hondureña' },
  { code: 'HR', label: 'Croacia', phone: '385', suggested: false, demonym: 'Croata' },
  { code: 'HT', label: 'Haití', phone: '509', suggested: false, demonym: 'Haitiana' },
  { code: 'HU', label: 'Hungría', phone: '36', suggested: false, demonym: 'Húngara' },
  { code: 'ID', label: 'Indonesia', phone: '62', suggested: false, demonym: 'Indonesia' }, // No cambia en género.
  { code: 'IE', label: 'Irlanda', phone: '353', suggested: false, demonym: 'Irlandesa' },
  { code: 'IL', label: 'Israel', phone: '972', suggested: false, demonym: 'Israelí' },
  { code: 'IM', label: 'Isla de Man', phone: '44', suggested: false, demonym: 'Mannesa' },
  { code: 'IN', label: 'India', phone: '91', suggested: false, demonym: 'India' }, // No cambia en género.
  { code: 'IO', label: 'Territorio Británico del Océano Índico', phone: '246', suggested: false, demonym: 'Del Territorio Británico del Océano Índico' },
  { code: 'IQ', label: 'Irak', phone: '964', suggested: false, demonym: 'Iraquí' },
  { code: 'IR', label: 'Irán', phone: '98', suggested: false, demonym: 'Iraní' },
  { code: 'IS', label: 'Islandia', phone: '354', suggested: false, demonym: 'Islandesa' },
  { code: 'IT', label: 'Italia', phone: '39', suggested: false, demonym: 'Italiana' },
  { code: 'JE', label: 'Jersey', phone: '44', suggested: false, demonym: 'Jersiana' },
  { code: 'JM', label: 'Jamaica', phone: '1-876', suggested: false, demonym: 'Jamaiquina' },
  { code: 'JO', label: 'Jordania', phone: '962', suggested: false, demonym: 'Jordana' },
  { code: 'JP', label: 'Japón', phone: '81', suggested: false, demonym: 'Japonesa' },
  { code: 'KE', label: 'Kenia', phone: '254', suggested: false, demonym: 'Keniana' },
  { code: 'KG', label: 'Kirguistán', phone: '996', suggested: false, demonym: 'Kirguís' },
  { code: 'KH', label: 'Camboya', phone: '855', suggested: false, demonym: 'Camboyana' },
  { code: 'KI', label: 'Kiribati', phone: '686', suggested: false, demonym: 'Kiribatiana' },
  { code: 'KM', label: 'Comoras', phone: '269', suggested: false, demonym: 'Comorense' },
  { code: 'KN', label: 'San Cristóbal y Nieves', phone: '1-869', suggested: false, demonym: 'De San Cristóbal y Nieves' },
  { code: 'KP', label: 'Corea del Norte', phone: '850', suggested: false, demonym: 'Norcoreana' },
  { code: 'KR', label: 'Corea del Sur', phone: '82', suggested: false, demonym: 'Surcoreana' },
  { code: 'KW', label: 'Kuwait', phone: '965', suggested: false, demonym: 'Kuwaití' },
  { code: 'KY', label: 'Islas Caimán', phone: '1-345', suggested: false, demonym: 'Caimanesa' },
  { code: 'KZ', label: 'Kazajistán', phone: '7', suggested: false, demonym: 'Kazaja' },
  { code: 'LA', label: 'Laos', phone: '856', suggested: false, demonym: 'De Laos' },
  { code: 'LB', label: 'Líbano', phone: '961', suggested: false, demonym: 'Libanesa' },
  { code: 'LC', label: 'Santa Lucía', phone: '1-758', suggested: false, demonym: 'Santa Luciana' },
  { code: 'LI', label: 'Liechtenstein', phone: '423', suggested: false, demonym: 'De Liechtenstein' },
  { code: 'LK', label: 'Sri Lanka', phone: '94', suggested: false, demonym: 'De Sri Lanka' },
  { code: 'LR', label: 'Liberia', phone: '231', suggested: false, demonym: 'Liberiana' },
  { code: 'LS', label: 'Lesoto', phone: '266', suggested: false, demonym: 'Lesotense' },
  { code: 'LT', label: 'Lituania', phone: '370', suggested: false, demonym: 'Lituana' },
  { code: 'LU', label: 'Luxemburgo', phone: '352', suggested: false, demonym: 'Luxemburguesa' },
  { code: 'LV', label: 'Letonia', phone: '371', suggested: false, demonym: 'Letona' },
  { code: 'LY', label: 'Libia', phone: '218', suggested: false, demonym: 'Libia' },
  { code: 'MA', label: 'Marruecos', phone: '212', suggested: false, demonym: 'Marroquí' },
  { code: 'MC', label: 'Mónaco', phone: '377', suggested: false, demonym: 'Monegasca' },
  { code: 'MD', label: 'Moldavia', phone: '373', suggested: false, demonym: 'Moldava' },
  { code: 'ME', label: 'Montenegro', phone: '382', suggested: false, demonym: 'Montenegrina' },
  { code: 'MF', label: 'San Martín', phone: '590', suggested: false, demonym: 'Sanmartinense' },
  { code: 'MG', label: 'Madagascar', phone: '261', suggested: false, demonym: 'Malgache' },
  { code: 'MH', label: 'Islas Marshall', phone: '692', suggested: false, demonym: 'Marshallense' },
  { code: 'MK', label: 'Macedonia del Norte', phone: '389', suggested: false, demonym: 'Macedonia del Norte' },
  { code: 'ML', label: 'Malí', phone: '223', suggested: false, demonym: 'Maliense' },
  { code: 'MM', label: 'Birmania', phone: '95', suggested: false, demonym: 'Birmana' },
  { code: 'MN', label: 'Mongolia', phone: '976', suggested: false, demonym: 'Mongola' },
  { code: 'MO', label: 'Macao', phone: '853', suggested: false, demonym: 'Macaense' },
  { code: 'MP', label: 'Islas Marianas del Norte', phone: '1-670', suggested: false, demonym: 'Nortemarianense' },
  { code: 'MQ', label: 'Martinica', phone: '596', suggested: false, demonym: 'Martiniquesa' },
  { code: 'MR', label: 'Mauritania', phone: '222', suggested: false, demonym: 'Mauritana' },
  { code: 'MS', label: 'Montserrat', phone: '1-664', suggested: false, demonym: 'Montserratense' },
  { code: 'MT', label: 'Malta', phone: '356', suggested: false, demonym: 'Maltesa' },
  { code: 'MU', label: 'Mauricio', phone: '230', suggested: false, demonym: 'Mauriciana' },
  { code: 'MV', label: 'Maldivas', phone: '960', suggested: false, demonym: 'Maldiva' },
  { code: 'MW', label: 'Malaui', phone: '265', suggested: false, demonym: 'Malauí' },
  { code: 'MX', label: 'México', phone: '52', suggested: false, demonym: 'Mexicana' },
  { code: 'MY', label: 'Malasia', phone: '60', suggested: false, demonym: 'Malaya' },
  { code: 'MZ', label: 'Mozambique', phone: '258', suggested: false, demonym: 'Mozambiqueña' },
  { code: 'NA', label: 'Namibia', phone: '264', suggested: false, demonym: 'Namibia' }, // No cambia en género.
  { code: 'NC', label: 'Nueva Caledonia', phone: '687', suggested: false, demonym: 'Neocaledonia' }, // No cambia en género.
  { code: 'NE', label: 'Níger', phone: '227', suggested: false, demonym: 'Nigerina' },
  { code: 'NF', label: 'Isla Norfolk', phone: '672', suggested: false, demonym: 'Norfolquense' },
  { code: 'NG', label: 'Nigeria', phone: '234', suggested: false, demonym: 'Nigeriana' },
  { code: 'NI', label: 'Nicaragua', phone: '505', suggested: false, demonym: 'Nicaragüense' },
  { code: 'NL', label: 'Países Bajos', phone: '31', suggested: false, demonym: 'Neerlandesa' },
  { code: 'NO', label: 'Noruega', phone: '47', suggested: false, demonym: 'Noruega' }, // No cambia en género.
  { code: 'NP', label: 'Nepal', phone: '977', suggested: false, demonym: 'Nepalí' },
  { code: 'NR', label: 'Nauru', phone: '674', suggested: false, demonym: 'Nauruana' },
  { code: 'NU', label: 'Niue', phone: '683', suggested: false, demonym: 'Niueña' },
  { code: 'NZ', label: 'Nueva Zelanda', phone: '64', suggested: false, demonym: 'Neozelandesa' },
  { code: 'OM', label: 'Omán', phone: '968', suggested: false, demonym: 'Omaní' },
  { code: 'PA', label: 'Panamá', phone: '507', suggested: false, demonym: 'Panameña' },
  { code: 'PE', label: 'Perú', phone: '51', suggested: false, demonym: 'Peruana' },
  { code: 'PF', label: 'Polinesia Francesa', phone: '689', suggested: false, demonym: 'Polinesia Francesa' }, // No cambia en género.
  { code: 'PG', label: 'Papúa Nueva Guinea', phone: '675', suggested: false, demonym: 'Papuana' },
  { code: 'PH', label: 'Filipinas', phone: '63', suggested: false, demonym: 'Filipina' },
  { code: 'PK', label: 'Pakistán', phone: '92', suggested: false, demonym: 'Pakistani' }, // No cambia en género.
  { code: 'PL', label: 'Polonia', phone: '48', suggested: false, demonym: 'Polaca' },
  { code: 'PM', label: 'San Pedro y Miquelón', phone: '508', suggested: false, demonym: 'Sanpedrina' },
  { code: 'PN', label: 'Islas Pitcairn', phone: '870', suggested: false, demonym: 'Pitcairnense' },
  { code: 'PR', label: 'Puerto Rico', phone: '1', suggested: false, demonym: 'Portorriqueña' },
  { code: 'PS', label: 'Palestina', phone: '970', suggested: false, demonym: 'De los Territorios Palestinos' },
  { code: 'PT', label: 'Portugal', phone: '351', suggested: false, demonym: 'Portuguesa' },
  { code: 'PW', label: 'Palaos', phone: '680', suggested: false, demonym: 'Palauana' },
  { code: 'PY', label: 'Paraguay', phone: '595', suggested: false, demonym: 'Paraguaya' },
  { code: 'QA', label: 'Catar', phone: '974', suggested: false, demonym: 'Catarí' },
  { code: 'RE', label: 'Reunión', phone: '262', suggested: false, demonym: 'Reunionense' },
  { code: 'RO', label: 'Rumania', phone: '40', suggested: false, demonym: 'Rumana' },
  { code: 'RS', label: 'Serbia', phone: '381', suggested: false, demonym: 'Serbia' }, // No cambia en género.
  { code: 'RU', label: 'Rusia', phone: '7', suggested: false, demonym: 'Rusa' },
  { code: 'RW', label: 'Ruanda', phone: '250', suggested: false, demonym: 'Ruandesa' },
  { code: 'SA', label: 'Arabia Saudita', phone: '966', suggested: false, demonym: 'Saudí' },
  { code: 'SB', label: 'Islas Salomón', phone: '677', suggested: false, demonym: 'Salomonense' },
  { code: 'SC', label: 'Seychelles', phone: '248', suggested: false, demonym: 'Seichelense' },
  { code: 'SD', label: 'Sudán', phone: '249', suggested: false, demonym: 'Sudanesa' },
  { code: 'SE', label: 'Suecia', phone: '46', suggested: false, demonym: 'Sueca' },
  { code: 'SG', label: 'Singapur', phone: '65', suggested: false, demonym: 'Singapurense' },
  { code: 'SH', label: 'Santa Elena', phone: '290', suggested: false, demonym: 'Santa Elena' }, // No cambia en género.
  { code: 'SI', label: 'Eslovenia', phone: '386', suggested: false, demonym: 'Eslovena' },
  { code: 'SJ', label: 'Svalbard y Jan Mayen', phone: '47', suggested: false, demonym: 'De Svalbard y Jan Mayen' },
  { code: 'SK', label: 'Eslovaquia', phone: '421', suggested: false, demonym: 'Eslovaca' },
  { code: 'SL', label: 'Sierra Leona', phone: '232', suggested: false, demonym: 'Sierraleonesa' },
  { code: 'SM', label: 'San Marino', phone: '378', suggested: false, demonym: 'Sanmarinense' },
  { code: 'SN', label: 'Senegal', phone: '221', suggested: false, demonym: 'Senegalesa' },
  { code: 'SO', label: 'Somalia', phone: '252', suggested: false, demonym: 'Somalí' },
  { code: 'SR', label: 'Surinam', phone: '597', suggested: false, demonym: 'Surinamesa' },
  { code: 'SS', label: 'Sudán del Sur', phone: '211', suggested: false, demonym: 'Sursudanesa' },
  { code: 'ST', label: 'Santo Tomé y Príncipe', phone: '239', suggested: false, demonym: 'Santotomense' },
  { code: 'SV', label: 'El Salvador', phone: '503', suggested: false, demonym: 'Salvadoreña' },
  { code: 'SY', label: 'Siria', phone: '963', suggested: false, demonym: 'Siria' }, // No cambia en género.
  { code: 'SZ', label: 'Esuatini', phone: '268', suggested: false, demonym: 'Esuatini' }, // No cambia en género.
  { code: 'TC', label: 'Islas Turcas y Caicos', phone: '1-649', suggested: false, demonym: 'Turcas y Caicos' }, // No cambia en género.
  { code: 'TD', label: 'Chad', phone: '235', suggested: false, demonym: 'Chadiana' },
  { code: 'TF', label: 'Territorios Australes Franceses', phone: '262', suggested: false, demonym: 'De los Territorios Australes Franceses' },
  { code: 'TG', label: 'Togo', phone: '228', suggested: false, demonym: 'Togolesa' },
  { code: 'TH', label: 'Tailandia', phone: '66', suggested: false, demonym: 'Tailandesa' },
  { code: 'TJ', label: 'Tayikistán', phone: '992', suggested: false, demonym: 'Tayika' },
  { code: 'TK', label: 'Tokelau', phone: '690', suggested: false, demonym: 'Tokelauense' },
  { code: 'TL', label: 'Timor-Leste', phone: '670', suggested: false, demonym: 'De Timor-Leste' },
  { code: 'TM', label: 'Turkmenistán', phone: '993', suggested: false, demonym: 'Turcomana' },
  { code: 'TN', label: 'Túnez', phone: '216', suggested: false, demonym: 'Tunecina' },
  { code: 'TO', label: 'Tonga', phone: '676', suggested: false, demonym: 'Tongana' },
  { code: 'TR', label: 'Turquía', phone: '90', suggested: false, demonym: 'Turca' },
  { code: 'TT', label: 'Trinidad y Tobago', phone: '1-868', suggested: false, demonym: 'Trinitense' },
  { code: 'TV', label: 'Tuvalu', phone: '688', suggested: false, demonym: 'Tuvaluana' },
  { code: 'TW', label: 'Taiwán', phone: '886', suggested: false, demonym: 'Taiwanesa' },
  { code: 'TZ', label: 'Tanzania', phone: '255', suggested: false, demonym: 'Tanzana' },
  { code: 'UA', label: 'Ucrania', phone: '380', suggested: false, demonym: 'Ucraniana' },
  { code: 'UG', label: 'Uganda', phone: '256', suggested: false, demonym: 'Ugandesa' },
  { code: 'UM', label: 'Islas menores alejadas de los Estados Unidos', phone: '1', suggested: false, demonym: 'De las Islas menores alejadas de los Estados Unidos' },
  { code: 'US', label: 'Estados Unidos', phone: '1', suggested: false, demonym: 'Estadounidense' },
  { code: 'UY', label: 'Uruguay', phone: '598', suggested: false, demonym: 'Uruguaya' },
  { code: 'UZ', label: 'Uzbekistán', phone: '998', suggested: false, demonym: 'Uzbeka' },
  { code: 'VA', label: 'Ciudad del Vaticano', phone: '379', suggested: false, demonym: 'Vaticana' },
  { code: 'VC', label: 'San Vicente y las Granadinas', phone: '1-784', suggested: false, demonym: 'Sanvicentina' },
  { code: 'VE', label: 'Venezuela', phone: '58', suggested: false, demonym: 'Venezolana' },
  { code: 'VG', label: 'Islas Vírgenes Británicas', phone: '1-284', suggested: false, demonym: 'Vírgenes Británicas' }, // No cambia en género.
  { code: 'VI', label: 'Islas Vírgenes de los Estados Unidos', phone: '1-340', suggested: false, demonym: 'Vírgenes de los Estados Unidos' }, // No cambia en género.
  { code: 'VN', label: 'Vietnam', phone: '84', suggested: false, demonym: 'Vietnamita' },
  { code: 'VU', label: 'Vanuatu', phone: '678', suggested: false, demonym: 'Vanuatuense' },
  { code: 'WF', label: 'Wallis y Futuna', phone: '681', suggested: false, demonym: 'Wallis y Futuna' }, // No cambia en género.
  { code: 'WS', label: 'Samoa', phone: '685', suggested: false, demonym: 'Samoana' },
  { code: 'XK', label: 'Kosovo', phone: '383', suggested: false, demonym: 'Kosovar' }, // No cambia en género.
  { code: 'YE', label: 'Yemen', phone: '967', suggested: false, demonym: 'Yemení' },
  { code: 'YT', label: 'Mayotte', phone: '262', suggested: false, demonym: 'Mayoutense' },
  { code: 'ZA', label: 'Sudáfrica', phone: '27', suggested: false, demonym: 'Sudafricana' },
  { code: 'ZM', label: 'Zambia', phone: '260', suggested: false, demonym: 'Zambiana' },
  { code: 'ZW', label: 'Zimbabue', phone: '263', suggested: false, demonym: 'Zimbabuense' },
];

export const partidoCodigoArray: { partido: string; codigo: number }[] = [
  { partido: 'ADOLFO ALSINA', codigo: 1 },
  { partido: 'ALBERTI', codigo: 2 },
  { partido: 'ALMIRANTE BROWN', codigo: 3 },
  { partido: 'AVELLANEDA', codigo: 4 },
  { partido: 'AYACUCHO', codigo: 5 },
  { partido: 'AZUL', codigo: 6 },
  { partido: 'BAHÍA BLANCA', codigo: 7 },
  { partido: 'BALCARCE', codigo: 8 },
  { partido: 'BARADERO', codigo: 9 },
  { partido: 'BARTOLOMÉ MITRE', codigo: 10 },
  { partido: 'BOLIVAR', codigo: 11 },
  { partido: 'BRAGADO', codigo: 12 },
  { partido: 'BRANDSEN', codigo: 13 },
  { partido: 'CAMPANA', codigo: 14 },
  { partido: 'CAÑUELAS', codigo: 15 },
  { partido: 'CARLOS CASARES', codigo: 16 },
  { partido: 'CARLOS TEJEDOR', codigo: 17 },
  { partido: 'CARMEN DE ARECO', codigo: 18 },
  { partido: 'DAIREAUX', codigo: 19 },
  { partido: 'CASTELLI', codigo: 20 },
  { partido: 'COLÓN', codigo: 21 },
  { partido: 'CORONEL DORREGO', codigo: 22 },
  { partido: 'CORONEL PRINGLES', codigo: 23 },
  { partido: 'CORONEL SUAREZ', codigo: 24 },
  { partido: 'LANÚS', codigo: 25 },
  { partido: 'CHACABUCO', codigo: 26 },
  { partido: 'CHASCOMÚS', codigo: 27 },
  { partido: 'CHIVILCOY', codigo: 28 },
  { partido: 'DOLORES', codigo: 29 },
  { partido: 'ESTEBAN ECHEVERRÍA', codigo: 30 },
  { partido: 'EXALTACIÓN DE LA CRUZ', codigo: 31 },
  { partido: 'FLORENCIO VARELA', codigo: 32 },
  { partido: 'GENERAL ALVARADO', codigo: 33 },
  { partido: 'GENERAL ALVEAR', codigo: 34 },
  { partido: 'GENERAL ARENALES', codigo: 35 },
  { partido: 'GENERAL BELGRANO', codigo: 36 },
  { partido: 'GENERAL GUIDO', codigo: 37 },
  { partido: 'ZÁRATE', codigo: 38 },
  { partido: 'GENERAL MADARIAGA', codigo: 39 },
  { partido: 'GENERAL LAMADRID', codigo: 40 },
  { partido: 'GENERAL LAS HERAS', codigo: 41 },
  { partido: 'GENERAL LAVALLE', codigo: 42 },
  { partido: 'GENERAL PAZ', codigo: 43 },
  { partido: 'GENERAL PINTO', codigo: 44 },
  { partido: 'GENERAL PUEYRREDÓN', codigo: 45 },
  { partido: 'GENERAL RODRIGUEZ', codigo: 46 },
  { partido: 'GENERAL SAN MARTÍN', codigo: 47 },
  { partido: 'GENERAL SARMIENTO', codigo: 48 },
  { partido: 'GENERAL VIAMONTE', codigo: 49 },
  { partido: 'GENERAL VILLEGAS', codigo: 50 },
  { partido: 'GONZALEZ CHAVES', codigo: 51 },
  { partido: 'GUAMINI', codigo: 52 },
  { partido: 'JUAREZ', codigo: 53 },
  { partido: 'JUNIN', codigo: 54 },
  { partido: 'LA PLATA', codigo: 55 },
  { partido: 'LAPRIDA', codigo: 56 },
  { partido: 'TIGRE', codigo: 57 },
  { partido: 'LAS FLORES', codigo: 58 },
  { partido: 'LEANDRO N ALEM', codigo: 59 },
  { partido: 'LINCOLN', codigo: 60 },
  { partido: 'LOBERÍA', codigo: 61 },
  { partido: 'LOBOS', codigo: 62 },
  { partido: 'LOMAS DE ZAMORA', codigo: 63 },
  { partido: 'LUJÁN', codigo: 64 },
  { partido: 'MAGDALENA', codigo: 65 },
  { partido: 'MAIPÚ', codigo: 66 },
  { partido: 'SALTO', codigo: 67 },
  { partido: 'MARCOS PAZ', codigo: 68 },
  { partido: 'MAR CHIQUITA', codigo: 69 },
  { partido: 'LA MATANZA', codigo: 70 },
  { partido: 'MERCEDES', codigo: 71 },
  { partido: 'MERLO', codigo: 72 },
  { partido: 'MONTE', codigo: 73 },
  { partido: 'MORENO', codigo: 74 },
  { partido: 'NAVARRO', codigo: 75 },
  { partido: 'NECOCHEA', codigo: 76 },
  { partido: 'NUEVE DE JULIO', codigo: 77 },
  { partido: 'OLAVARRÍA', codigo: 78 },
  { partido: 'PATAGONES', codigo: 79 },
  { partido: 'PEHUAJÓ', codigo: 80 },
  { partido: 'PELLEGRINI', codigo: 81 },
  { partido: 'PERGAMINO', codigo: 82 },
  { partido: 'PILA', codigo: 83 },
  { partido: 'PILAR', codigo: 84 },
  { partido: 'PUAN', codigo: 85 },
  { partido: 'QUILMES', codigo: 86 },
  { partido: 'RAMALLO', codigo: 87 },
  { partido: 'RAUCH', codigo: 88 },
  { partido: 'RIVADAVIA', codigo: 89 },
  { partido: 'ROJAS', codigo: 90 },
  { partido: 'ROQUE PEREZ', codigo: 91 },
  { partido: 'SAAVEDRA', codigo: 92 },
  { partido: 'SALADILLO', codigo: 93 },
  { partido: 'SAN ANDRÉS DE GILES', codigo: 94 },
  { partido: 'SAN ANTONIO DE ARECO', codigo: 95 },
  { partido: 'SAN FERNANDO', codigo: 96 },
  { partido: 'SAN ISIDRO', codigo: 97 },
  { partido: 'SAN NICOLÁS', codigo: 98 },
  { partido: 'SAN PEDRO', codigo: 99 },
  { partido: 'SAN VICENTE', codigo: 100 },
  { partido: 'MORÓN', codigo: 101 },
  { partido: 'SUIPACHA', codigo: 102 },
  { partido: 'TANDIL', codigo: 103 },
  { partido: 'TAPALQUÉ', codigo: 104 },
  { partido: 'TORDILLO', codigo: 105 },
  { partido: 'TORNQUIST', codigo: 106 },
  { partido: 'TRENQUE LAUQUEN', codigo: 107 },
  { partido: 'TRES ARROYOS', codigo: 108 },
  { partido: 'VEINTICINCO DE MAYO', codigo: 109 },
  { partido: 'VICENTE LÓPEZ', codigo: 110 },
  { partido: 'VILLARINO', codigo: 111 },
  { partido: 'CORONEL ROSALES', codigo: 113 },
  { partido: 'BERISSO', codigo: 114 },
  { partido: 'ENSENADA', codigo: 115 },
  { partido: 'SAN CAYETANO', codigo: 116 },
  { partido: 'TRES DE FEBRERO', codigo: 117 },
  { partido: 'ESCOBAR', codigo: 118 },
  { partido: 'HIPÓLITO YRIGOYEN', codigo: 119 },
  { partido: 'BERAZATEGUI', codigo: 120 },
  { partido: 'CAPITÁN SARMIENTO', codigo: 121 },
  { partido: 'SALIQUELÓ', codigo: 122 },
  { partido: 'LA COSTA', codigo: 123 },
  { partido: 'PINAMAR', codigo: 124 },
  { partido: 'VILLA GESELL', codigo: 125 },
  { partido: 'MONTE HERMOSO', codigo: 126 },
  { partido: 'TRES LOMAS', codigo: 127 },
  { partido: 'FLORENTINO AMEGHINO', codigo: 128 },
  { partido: 'PRESIDENTE PERÓN', codigo: 129 },
  { partido: 'EZEIZA', codigo: 130 },
  { partido: 'SAN MIGUEL', codigo: 131 },
  { partido: 'JOSÉ C. PAZ', codigo: 132 },
  { partido: 'MALVINAS ARGENTINAS', codigo: 133 },
  { partido: 'PUNTA INDIO', codigo: 134 },
  { partido: 'HURLINGHAM', codigo: 135 },
  { partido: 'ITUZAINGÓ', codigo: 136 },
  { partido: 'ISLAS BARADERO', codigo: 309 },
  { partido: 'ISLAS CAMPANA', codigo: 314 },
  { partido: 'ISLAS ZÁRATE', codigo: 338 },
  { partido: 'ISLAS TIGRE', codigo: 357 },
  { partido: 'ISLAS RAMALLO', codigo: 387 },
  { partido: 'ISLAS SAN FERNANDO', codigo: 396 },
  { partido: 'ISLAS SAN NICOLÁS', codigo: 398 },
  { partido: 'ISLAS SAN PEDRO', codigo: 399 },
];

export const opcionesDocumento = [
  { valor: EnumTiposDocumento.DNI, etiqueta: "DNI" },
  { valor: EnumTiposDocumento.CEDULA_IDENTIDAD, etiqueta: "CÉDULA DE IDENTIDAD" },
  { valor: EnumTiposDocumento.LIBRETA_ENROLAMIENTO, etiqueta: "LIBRETA DE ENROLAMIENTO" },
  { valor: EnumTiposDocumento.LIBRETA_CIVICA, etiqueta: "LIBRETA CÍVICA" },
  { valor: EnumTiposDocumento.PASAPORTE, etiqueta: "PASAPORTE" },
  { valor: EnumTiposDocumento.DOCUMENTO_EXTRANJERO, etiqueta: "DOCUMENTO EXTRANJERO" },
  { valor: EnumTiposDocumento.CEDULA_IDENTIDAD_EXTRANJERO, etiqueta: "CÉDULA DE IDENTIDAD EXTRANJERO" },
];